module.exports = __webpack_public_path__ + "images/minus_small-6b49f5d80d0d650b99771596b95a44f1.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/minus_small.svg
// module id = 229
// module chunks = 0